import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import Hero from "../components/sections/Hero";
import ClinicsBand from "../components/sections/ClinicsBand";
import ServicesGrid from "../components/sections/ServicesGrid";
import Pillars from "../components/sections/Pillars";
import Testimonials from "../components/sections/Testimonials";
import FinalCTA from "../components/sections/FinalCTA";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#FAF7F2] text-[#1A1A1A]" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <ClinicsBand />
        <ServicesGrid />
        <Pillars />
        <Testimonials />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
